import React, { useContext, useEffect } from "react";
import { AppDataContext } from "../app/AppDataContext";

const GlobalLoaderController = () => {
  const { loading } = useContext(AppDataContext);

  useEffect(() => {
    const $ = window.$;
    if (!$) return;

    const $loader = $(".quarter-overlay");

    if (loading) {
      $loader.show();
    } else {
      $loader.fadeOut(800);

      // Re-initialize sliders after data load
      // This is necessary because the sliders are rendered conditionally based on data,
      // and main.js runs before the data is available.
      reinitBgImages($);
      reinitSliders($);
    }
  }, [loading]);

  return null;
};

const reinitBgImages = ($) => {
  var $backgroundImage = $(".bg-image, .bg-image-top");
  $backgroundImage.each(function () {
    var $this = $(this),
      $bgImage = $this.data("bs-bg");
    $this.css("background-image", "url(" + $bgImage + ")");
  });
};

const reinitSliders = ($) => {
  // Helper to init slick if not already initialized
  const initSlick = (selector, options) => {
    const $el = $(selector);
    if ($el.length && !$el.hasClass("slick-initialized")) {
      $el.slick(options);
    }
  };

  /* --------------------------------------------------------
      # upcoming-project-slider-1
  --------------------------------------------------------- */
  initSlick(".ltn__upcoming-project-slider-1-active", {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
    nextArrow:
      '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /* --------------------------------------------------------
      18. Blog Slider One
  --------------------------------------------------------- */
  initSlick(".ltn__blog-slider-one-active", {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
    nextArrow:
      '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /* --------------------------------------------------------
      16-1. Product Slider One
  --------------------------------------------------------- */
  initSlick(".ltn__product-slider-one-active", {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
    nextArrow:
      '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /* --------------------------------------------------------
      15. Slider One Active 
  --------------------------------------------------------- */
  initSlick(".ltn__slide-one-active", {
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    dots: false,
    fade: true,
    cssEase: "linear",
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
    nextArrow:
      '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  });
};

export default GlobalLoaderController;
